// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"07079f9b6d972a03b065","133":"5958356468463dcafd64","134":"a96c677694601e2c3565","181":"455a02d79912cc5363d2"}[chunkId] + ".chunk.js";
};